







































import Vue from 'vue';
import I18n from '@/plugins/i18n';

export default Vue.extend({
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    birthdayPicker: {
      type: Boolean,
      default: false,
    },
    maxDate: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      date: this.value,
    };
  },
  computed: {
    userLocale(): string {
      return I18n.getUserLanguage();
    },
  },
  watch: {
    date(val) {
      this.$emit('input', val);
    },
    show(val) {
      if (this.birthdayPicker && val && !this.date) {
        setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR'
          // rewind startdate about 55 years
          let startDate = new Date();
          startDate.setFullYear(startDate.getFullYear() - 55);
          this.date = startDate.toISOString().substring(0, 10)
        })
      }
    }
  },
  methods: {
    save(date: string) {
      this.$refs.menu.save(date)
      this.show = false
    }
  }
});
